import axios from 'axios';
import { showAlert } from './alerts';


export const verifyEmail = async (vToken) => {
    try {
        console.log({vToken});
        const {data} = await axios.post('/api/v1/users/verifyEmail', {vToken});
        console.log(data)
        if(data.status === 'success'){
            
            setTimeout(() => {

                window.location.assign('/login?verified=true');
            }, 5000)
        }

    } catch (error) {
        showAlert('error', error.response.data.message);
        setTimeout(() => window.location.assign('/signup'), 5000)
    }
}